import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { T } from "react-translator-component";
import GCBackButton from "../GreenCity/GCBackButton";
import LoadingModal from "../LoadingModal";
import MessageModal from "../Models/GreenCity/MessageModal";
import { ErrorMessageModal } from "../ErrorMessageModal";
import TwoButtonModal from "../TwoButtonModal";
import RefundEventApplicationDetail from "./RefundEventApplicationDetail";
import { Box, Button } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { isMemberRole } from "../../util/utils";
import appServices from "../../services/app-services/appServices";

export default function RefundEventFee() {
  const navigate = useNavigate();
  const location = useLocation();
  const { postEventUserId } = location.state || {};

  const [postDetail, setPostDetail] = useState<any>();
  const [userDetail, setUserDetail] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [eventUserDetail, setEventUserDetail] = useState<any>();

  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [openModalMessage, setOpenModalMessage] = useState<string>("");

  const fixedJsonString = eventUserDetail?.application_details ?
    eventUserDetail.application_details.replace(/=>/g, ":").replace(/nil/g, "null") : '[]';
  const paymentDetails = JSON.parse(fixedJsonString);

  useEffect(() => {
    getUserPaymentDetail();
  }, []);

  useEffect(() => {
    if (!eventUserDetail) return
    getEventDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventUserDetail]);

  const getUserPaymentDetail = async () => {
    try {
      setLoading(true);
      // 最新の申し込み内容を取得する
      const response = await appServices.getSinglePostEventUsers(postEventUserId);
      setEventUserDetail(response?.post_event_user);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getEventDetails = async () => {
    try {
      setLoading(true);
      const res = await appServices.getSingleEventById(eventUserDetail?.post_id);
      setPostDetail(res?.post);

      const response = await appServices.getSingleUser(eventUserDetail?.user_id);
      setUserDetail(response?.user);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const refund = async () => {
    setShowConfirmationModal(false);

    try {
      setLoading(true);
      await appServices.refundPostEventUsers(eventUserDetail?.id);
      setOpenModalMessage(`${T("event_users_refunded")}`);
      setShowSuccessModal(true);
      return true;
    } catch (error: any) {
      const errorResponse = error?.response?.data?.message ?? T("api_unknown_error")
      setOpenModalMessage(
        typeof errorResponse === "object" ?
        errorResponse.join("\n") :
        errorResponse
      )
      console.error(error);
      setShowErrorModal(true);
      return false
    } finally {
      setLoading(false);
    }
  };

  const handleCloseMessageModal = () => {
    if (showSuccessModal) {
      setShowSuccessModal(false);
      navigate("/myfarm");
    } else {
      setShowErrorModal(false);
    }
  }

  return (
    <>
      <Box>
        <LoadingModal visible={loading}/>

        <div style={styles.root}>
          <GCBackButton onClick={() => navigate(-1)} />

          <RefundEventApplicationDetail
            post={postDetail}
            applier={userDetail}
            paymentDetails={paymentDetails}
          />

          <Button
            color="secondary"
            sx={styles.submitButton}
            size={"large"}
            disabled={isMemberRole(postDetail?.member_group?.role)}
            onClick={() => setShowConfirmationModal(true)}
            variant="outlined"
            endIcon={<ArrowForwardIosIcon sx={styles.arrowIcon}/>}
          >
            {T("refund_entry_fee")}
          </Button>
        </div>
      </Box>

      <TwoButtonModal
        open={showConfirmationModal}
        message={`${T("event_payment_details_confirm_refund")}`}
        showButton={true}
        onContinue={refund}
        onClose={() => setShowConfirmationModal(false)}
      />

      <MessageModal
        open={showSuccessModal}
        message={openModalMessage}
        showButton={true}
        buttonText={T("close")}
        onContinue={() => handleCloseMessageModal()}
        onClose={() => handleCloseMessageModal()}
      />

      <ErrorMessageModal
        open={showErrorModal}
        messages={[openModalMessage]}
        showButton={true}
        onClose={() => handleCloseMessageModal()}
        alignLeft={openModalMessage.indexOf("\n") !== -1}
      />
    </>
  );
};

const styles = {
  submitButton: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    marginTop: "20px",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
  },
  arrowIcon: {
    position: "absolute",
    right: 0,
    top: 0,
    margin: "10px",
  },
  root: {
    paddingTop: 100,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: "12px",
  }
};
